export default __webpack_public_path__ + "locales/tr/ArchiveDialog.json?hash=a4847548100530d7ab48773de1dbeca7";